<template lang="pug">
  .action-show-products-element
    b-card.mb-0.card-inactive.p-2(no-body)
      .bg-white.mb-3
        fieldset(:disabled="disabled")
          b-form-row.align-items-center.justify-content-end(v-if="!disabled")
            b-col
              span.text-sm.text-success(v-if="isNew") Nuevo
            b-col(cols="auto")
              x-icon.icon-md.hover-danger.pointer.text-secondary(@click="$emit('destroy', element_id)")
          b-form-group(label="Buscar categoría:", v-for="(e_a, e_a_index) in Element_Attributes", :key="e_a.element_attribute_id", v-if="e_a.name == 'category_input'", :id="`element_attribute_${e_a.element_attribute_id}`")
            b-form-radio-group(:checked="e_a.value", :options="input_options", :disabled="disabled", @change="updateElementAttributeNow(e_a, $event)")
          b-form-group(label="Categoría del producto:", v-for="(e_a, e_a_index) in Element_Attributes", :key="e_a.element_attribute_id", v-if="e_a.name == 'category_id'", :id="`element_attribute_${e_a.element_attribute_id}`")
            k-select.disabled-white(v-if="category_input_type == 'id'", placeholder="- Seleccionar categoria -", :options="parsed_categories", :disabled="disabled", :value="e_a.value || null", @input="updateElementAttributeNow(e_a, $event)")
            b-form-group(v-else-if="category_input_type == 'text'")
              vue-tribute(:options="tributeOpts")
                b-form-input.disabled-white(placeholder="Nombre de categoria", :value="e_a.value", @input="updateElementAttribute(e_a, $event)")

</template>

<script>
import { createNamespacedHelpers, mapActions } from 'vuex'
const categoryController = createNamespacedHelpers('category')

import templateElementCommon from '@/helpers/template-element-common'
import Select from '@/components/Select.vue'
import Connector from '@/components/templates/connectors/Connector.vue'

import _debounce from 'lodash.debounce'

export default {
  mixins: [templateElementCommon],
  data () {
    return {
      input_options: [
        {text: 'Por ID', value: 'id'},
        {text: 'Por texto', value: 'text'}
      ]
    }
  },
  computed: {
    ...categoryController.mapState({
      categories: state => state.categories
    }),
    parsed_categories () {
      return this.categories.map(c => {
        return {
          label: c.name,
          id: c.category_id
        }
      })
    },
    category_input_type () {
      let category_input = this.getAttribute('category_input')
      if (category_input) {
        return category_input.value
      }

      return 'text'
    }
  },
  methods: {

  },
  created () {
    this.updateElementAttribute = _debounce((element_attribute, value) => {
      let attribute = JSON.parse(JSON.stringify(element_attribute))
      attribute.value = value
      this.updateAttribute(this.block_id, this.template_id, this.element_id, attribute)
    }, 2000, {leading: false, trailing: true})

    this.updateElementAttributeNow = (element_attribute, value) => {
      let attribute = JSON.parse(JSON.stringify(element_attribute))
      attribute.value = value
      this.updateAttribute(this.block_id, this.template_id, this.element_id, attribute)
    }
  },
  mounted () {

  },
  components: {
    'k-select': Select,
    'template-element-connector': Connector
  }
}
</script>

<style lang="scss" scoped>
  @import '@/assets/colors.scss';

  .action-show-products-element {

    &:not(:last-child) {
      margin-bottom: 1rem;
    }

    .entity-element {
      &:not(:last-child) {
        margin-bottom: 1rem;
      }
    }
  }
</style>
